import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { editorStore } from "./_editor_app/app/store";
import EditorApp from "./_editor_app/EditorApp";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    {/* <Provider store={store}>
      <App />
    </Provider> */}
    <Provider store={editorStore}>
      <EditorApp />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
